/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Import_HelpInputs */

const en_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import event groups and/or metadata without overwriting the existing project file`)
};

const fr_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des groupes d’événements et/ou des métadonnées sans écraser le projet existant`)
};

const de_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie Ereignisgruppen und/oder Metadaten, ohne die bestehende Projektdatei zu überschreiben.`)
};

const it_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa gruppi di eventi e/o metadati senza sovrascrivere il file di progetto esistente`)
};

const ru_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте группы событий и/или метаданные без перезаписи существующего файла проекта.`)
};

const es_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar grupos de eventos y/o metadatos sin sobrescribir el archivo de proyecto existente`)
};

const zh_cn2_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入事件组和/或元数据，而不覆盖现有项目文件`)
};

const ja_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のプロジェクト ファイルを上書きせずにイベント グループやメタデータをインポートします。`)
};

const hi_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मौजूदा प्रोजेक्ट फ़ाइल को ओवरराइट किए बिना इवेंट समूह और/या मेटाडेटा आयात करें`)
};

const pt_pt2_merge_import_help = /** @type {(inputs: Merge_Import_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe grupos de eventos e/ou metadados sem sobrescrever o arquivo de projeto existente.`)
};

/**
* | output |
* | --- |
* | "Import event groups and/or metadata without overwriting the existing project file" |
*
* @param {Merge_Import_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_import_help = /** @type {((inputs?: Merge_Import_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Import_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_import_help(inputs)
	if (locale === "de") return de_merge_import_help(inputs)
	if (locale === "it") return it_merge_import_help(inputs)
	if (locale === "ru") return ru_merge_import_help(inputs)
	if (locale === "es") return es_merge_import_help(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_import_help(inputs)
	if (locale === "ja") return ja_merge_import_help(inputs)
	if (locale === "hi") return hi_merge_import_help(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_import_help(inputs)
	return en_merge_import_help(inputs)
});